import React from 'react';
import './site.css';
import { HashLink } from 'react-router-hash-link';

const FooterContent = () => (
  <footer>
    <div className="container" style={{ position: 'relative', zIndex: 10 }}>
      <div className="footer-top">
        <div>
          <div className="footer-brand-name">Amatres<span>.</span></div>
          <p className="footer-tagline">Engineering reliable products for teams that care about quality. Bengaluru, India.</p>
        </div>
        <div className="footer-col">
          <div className="footer-col-title">Company</div>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/#services">Services</a></li>
            <li><a href="/#expertise">About</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <div className="footer-col-title">Services</div>
          <ul>
            <li><a href="/#tech-consulting">Tech Consulting</a></li>
            <li><a href="/#product-engineering">Product Engineering</a></li>
            <li><a href="/#cloud-devops">Cloud &amp; DevOps</a></li>
            <li><a href="/#ai-automation">AI-Driven Automation</a></li>
            <li><a href="/#m365-development">M365 Development</a></li>
            <li><a href="/#healthcare-tech">Healthcare Tech</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-btm">
        <div className="footer-copy">© {new Date().getFullYear()} Amatres Technologies. All rights reserved.</div>
        <div className="footer-contact">
          <a href="mailto:connect@amatrestechnologies.in">connect@amatrestechnologies.in</a>
          &nbsp;·&nbsp; Bengaluru, India
        </div>
      </div>
    </div>
  </footer>
);
const STACK_OPTIONS = [
  { group: 'Frontend', items: ['React', 'Next.js', 'Vue', 'Angular', 'TypeScript'] },
  { group: 'Backend', items: ['Node.js', '.NET', 'Python', 'Java', 'PHP', 'Go'] },
  { group: 'Mobile', items: ['React Native', 'Flutter', 'Swift', 'Kotlin'] },
  { group: 'Database', items: ['PostgreSQL', 'MySQL', 'MongoDB', 'Redis', 'Firebase'] },
  { group: 'Cloud', items: ['AWS', 'Azure', 'GCP', 'Vercel', 'Docker', 'Kubernetes'] },
  { group: 'Other', items: ['GraphQL', 'REST', 'GitHub', 'Terraform', 'Power Platform'] },
];

const StackSelector = ({ name }) => {
  const [selected, setSelected] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [custom, setCustom] = React.useState('');

  React.useEffect(() => {
    const form = document.querySelector('.contact-form');
    const handleReset = () => {
      setSelected([]);
      setCustom('');
      setOpen(false);
    };
    form?.addEventListener('reset', handleReset);
    return () => form?.removeEventListener('reset', handleReset);
  }, []);

  const toggle = (item) => {
    setSelected(prev =>
      prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item]
    );
  };

  const allSelected = custom.trim()
    ? [...selected, custom.trim()]
    : selected;
  return (
    <>
      <style>{`
        .stack-selector {
          display: flex;
          flex-direction: column;
          gap: 16px;
          background: #111111;
          border: 1px solid #2A2A2A;
          padding: 20px;
        }
        .stack-group-label {
          font-family: 'Space Mono', monospace;
          font-size: 8px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #6D28D9;
          margin-bottom: 8px;
          font-weight: 700;
        }
        .stack-pills {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
        .stack-pill {
          font-family: 'Space Mono', monospace;
          font-size: 8.5px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding: 6px 14px;
          border: 1px solid #2A2A2A;
          background: transparent;
          color: #888;
          cursor: pointer;
          border-radius: 100px;
          transition: all 0.2s;
          user-select: none;
        }
        .stack-pill:hover {
          border-color: #7C3AED;
          color: #F0EDE8;
        }
        .stack-pill.selected {
          background: linear-gradient(135deg, rgba(124,58,237,0.25), rgba(0,229,255,0.15));
          border-color: #00E5FF;
          color: #ffffff;
          box-shadow: 0 0 10px rgba(0,229,255,0.15);
        }
        .stack-selected-summary {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          color: #666;
          padding-top: 12px;
          border-top: 1px solid #1A1A1A;
          font-weight: 300;
        }
        .stack-selected-summary span {
          color: #00E5FF;
        }
          .stack-trigger {
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          padding: 4px 0;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          color: #666;
          font-weight: 300;
        }
        .stack-trigger:hover {
          color: #F0EDE8;
        }
        .stack-trigger-arrow {
          font-size: 16px;
          color: #6D28D9;
        }
        .stack-panel {
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding-top: 16px;
          border-top: 1px solid #1A1A1A;
        }
      `}</style>

      <input type="hidden" name={name} value={allSelected.join(', ')} />

      <div className="stack-selector">
        {/* Collapsed trigger row */}
        <div className="stack-trigger" onClick={() => setOpen(!open)}>
          <span className="stack-trigger-label">
            {allSelected.length === 0
              ? 'Select technologies'
              : <><span style={{ color: '#00E5FF' }}>{allSelected.length}</span> selected: {allSelected.join(', ')}</>
            }
          </span>
          <span className="stack-trigger-arrow" style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>▾</span>
        </div>

        {/* Expandable panel */}
        {open && (
          <div className="stack-panel">
            {STACK_OPTIONS.map(({ group, items }) => (
              <div key={group}>
                <div className="stack-group-label">{group}</div>
                <div className="stack-pills">
                  {items.map(item => (
                    <div
                      key={item}
                      className={`stack-pill ${selected.includes(item) ? 'selected' : ''}`}
                      onClick={() => toggle(item)}
                    >
                      {selected.includes(item) ? '✓ ' : ''}{item}
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {/* Free text for anything not in the list */}
            <div style={{ borderTop: '1px solid #1A1A1A', paddingTop: '14px' }}>
              <div className="stack-group-label">Not in the list? Add it</div>
              <input
                type="text"
                className="cf-input"
                placeholder="e.g. Supabase, Remix, Elixir..."
                value={custom}
                onChange={e => setCustom(e.target.value)}
                onBlur={e => {
                  const val = e.target.value;
                  const allItems = STACK_OPTIONS.flatMap(g => g.items);
                  const exactMatch = allItems.find(
                    item => item.toLowerCase() === val.trim().toLowerCase()
                  );
                  if (exactMatch) {
                    if (!selected.includes(exactMatch)) toggle(exactMatch);
                    setCustom('');
                  }
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    const val = e.target.value.trim();
                    if (!val) return;
                    const allItems = STACK_OPTIONS.flatMap(g => g.items);
                    const exactMatch = allItems.find(
                      item => item.toLowerCase() === val.toLowerCase()
                    );
                    if (exactMatch) {
                      if (!selected.includes(exactMatch)) toggle(exactMatch);
                    } else {
                      if (!selected.includes(val)) toggle(val);
                    }
                    setCustom('');
                  }
                }}
                style={{ marginTop: '6px' }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
/* ── SUCCESS POPUP ── */
const SuccessPopup = ({ onClose }) => (
  <>
    <style>{`
      @keyframes popupFadeIn {
        from { opacity: 0; }
        to   { opacity: 1; }
      }
      @keyframes popupSlideUp {
        from { opacity: 0; transform: translateY(32px) scale(0.97); }
        to   { opacity: 1; transform: translateY(0) scale(1); }
      }
      @keyframes checkDraw {
        from { stroke-dashoffset: 60; }
        to   { stroke-dashoffset: 0; }
      }
      @keyframes ringPulse {
        0%,100% { transform: scale(1); opacity: 0.6; }
        50%      { transform: scale(1.12); opacity: 0.2; }
      }

      .popup-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.72);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        animation: popupFadeIn 0.25s ease forwards;
      }

      .popup-card {
        background: rgba(14, 14, 18, 0.96);
        border: 1px solid rgba(255,255,255,0.08);
        border-radius: 24px;
        padding: 52px 48px 44px;
        max-width: 480px;
        width: 100%;
        text-align: center;
        position: relative;
        box-shadow:
          0 32px 80px rgba(0,0,0,0.6),
          0 0 0 1px rgba(124,58,237,0.15),
          inset 0 1px 0 rgba(255,255,255,0.06);
        animation: popupSlideUp 0.38s cubic-bezier(0.22,1,0.36,1) forwards;
        overflow: hidden;
      }

      /* Subtle glow behind the icon */
      .popup-card::before {
        content: '';
        position: absolute;
        top: -60px;
        left: 50%;
        transform: translateX(-50%);
        width: 260px;
        height: 260px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(124,58,237,0.18) 0%, transparent 70%);
        pointer-events: none;
      }

      .popup-close {
        position: absolute;
        top: 18px;
        right: 20px;
        background: none;
        border: 1px solid rgba(255,255,255,0.1);
        border-radius: 50%;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #666;
        font-size: 14px;
        line-height: 1;
        transition: border-color 0.2s, color 0.2s;
        padding: 0;
      }
      .popup-close:hover {
        border-color: rgba(255,255,255,0.3);
        color: #F0EDE8;
      }

      /* Animated check icon */
      .popup-icon-wrap {
        position: relative;
        width: 72px;
        height: 72px;
        margin: 0 auto 28px;
      }
      .popup-ring-pulse {
        position: absolute;
        inset: -10px;
        border-radius: 50%;
        border: 1px solid rgba(124,58,237,0.4);
        animation: ringPulse 2.4s ease-in-out infinite;
      }
      .popup-icon-circle {
        width: 72px;
        height: 72px;
        border-radius: 50%;
        background: rgba(124,58,237,0.12);
        border: 1.5px solid rgba(124,58,237,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
      }
      .popup-check-svg {
        width: 30px;
        height: 30px;
      }
      .popup-check-path {
        stroke: url(#check-grad);
        stroke-width: 2.5;
        stroke-linecap: round;
        stroke-linejoin: round;
        fill: none;
        stroke-dasharray: 60;
        stroke-dashoffset: 60;
        animation: checkDraw 0.55s cubic-bezier(0.22,1,0.36,1) 0.2s forwards;
      }

      .popup-eyebrow {
        font-family: 'Space Mono', monospace;
        font-size: 9px;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: #ffffff;
        margin-bottom: 12px;
        font-weight: 700;
      }

      .popup-title {
        font-family: 'Bebas Neue', cursive;
        font-size: clamp(36px, 6vw, 52px);
        line-height: 0.95;
        color: #F0EDE8;
        margin-bottom: 16px;
        letter-spacing: 0.01em;
      }
      .popup-title em {
        font-style: normal;
        background: linear-gradient(90deg, #7C3AED 0%, #00E5FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        display: block;
      }

      .popup-desc {
        font-family: 'DM Sans', sans-serif;
        font-size: 14px;
        color: rgba(255,255,255,0.9);
        line-height: 1.8;
        font-weight: 300;
        max-width: 340px;
        margin: 0 auto 32px;
      }

      /* Divider row with icon */
      .popup-divider {
        display: flex;
        align-items: center;
        gap: 14px;
        margin-bottom: 24px;
      }
      .popup-divider-line {
        flex: 1;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent);
      }
      .popup-divider-dot {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: linear-gradient(135deg, #7C3AED, #00E5FF);
      }

      /* Info row — response time badge */
      .popup-badge {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        background: linear-gradient(135deg, rgba(124,58,237,0.35) 0%, rgba(0,229,255,0.2) 100%);
        border: 1px solid rgba(0,229,255,0.4);
        border-radius: 100px;
        padding: 14px 24px;
        font-family: 'Space Mono', monospace;
        font-size: 11px;
        letter-spacing: 0.1em;
        color: #ffffff;
        text-transform: uppercase;
        margin-bottom: 28px;
        box-shadow: 0 0 20px rgba(124,58,237,0.25), 0 0 40px rgba(0,229,255,0.1);
        font-weight: 700;
        white-space: nowrap;
        max-width: 100%;
        overflow: hidden;
      }

      @media (max-width: 480px) {
        .popup-badge {
          white-space: normal;
          text-align: center;
          justify-content: center;
          font-size: 9px;
          padding: 12px 16px;
          letter-spacing: 0.06em;
        }
      
      .popup-badge-dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #00E5FF;
        box-shadow: 0 0 8px #00E5FF;
        flex-shrink: 0;
        animation: ringPulse 2s ease-in-out infinite;
      }

      .popup-cta-btn {
        font-family: 'Space Mono', monospace;
        font-size: 9.5px;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: #fff;
        background: linear-gradient(135deg, #7C3AED 0%, #00E5FF 100%);
        padding: 12px 32px;
        border-radius: 50px;
        border: none;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        transition: opacity 0.2s, transform 0.2s;
        text-decoration: none;
      }
      .popup-cta-btn:hover {
        opacity: 0.85;
        transform: translateY(-2px);
      }

      @media (max-width: 480px) {
        .popup-card {
          padding: 40px 20px 32px;
          border-radius: 16px;
        }
      }
    `}</style>

    <div className="popup-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="popup-card">

        <button className="popup-close" onClick={onClose} aria-label="Close">✕</button>

        {/* Animated check icon */}
        <div className="popup-icon-wrap">
          <div className="popup-ring-pulse" />
          <div className="popup-icon-circle">
            <svg className="popup-check-svg" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="check-grad" x1="0" y1="0" x2="1" y2="1">
                  <stop stopColor="#7C3AED" />
                  <stop offset="1" stopColor="#00E5FF" />
                </linearGradient>
              </defs>
              <path className="popup-check-path" d="M6 15.5 L12.5 22 L24 9" />
            </svg>
          </div>
        </div>

        <div className="popup-eyebrow">Message Received</div>

        <div className="popup-title">
          Message Sent
          <em>Successfully.</em>
        </div>

        <p className="popup-desc">
          We've received your project brief. Our team will review it and get back to you with a clear plan and next steps.
        </p>

        <div className="popup-badge">
          <span className="popup-badge-dot" />
          We'll contact you within 1 business day
        </div>

        <div className="popup-divider">
          <div className="popup-divider-line" />
          <div className="popup-divider-dot" />
          <div className="popup-divider-line" />
        </div>

        <button
          className="popup-cta-btn"
          onClick={onClose}
          style={{
            fontFamily:"'Space Mono', monospace",
            fontSize:'9.5px',
            letterSpacing:'0.14em',
            textTransform:'uppercase',
            color:'#fff',
            background:'linear-gradient(135deg, #7C3AED 0%, #00E5FF 100%)',
            padding:'12px 32px',
            borderRadius:'50px',
            border:'none',
            cursor:'pointer',
            display:'inline-flex',
            alignItems:'center',
            gap:'10px',
            textDecoration:'none',
            minWidth:'180px',
            justifyContent:'center',
          }}
        >
          Back to site →
        </button>

      </div>
    </div>
  </>
);

export default function Contact() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const [showPopup, setShowPopup] = React.useState(false);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Space+Mono:wght@400;700&family=DM+Sans:wght@300;400;500;600;700;800&display=swap');

        /* ─── PAGE SHELL ─── */
        .contact-page {
          min-height: 100vh;
          background: #080808;
          color: #F0EDE8;
          font-family: 'DM Sans', sans-serif;
        }
        .contact-page * {
          box-sizing: border-box;
        }

        /* ─── HERO ─── */
        .contact-hero {
          position: relative;
          padding: 90px 0 56px;
          overflow: hidden;
          border-bottom: 1px solid #1A1A1A;
        }
        @media (max-width: 768px) {
          .contact-hero {
            padding: 80px 0 40px;
            min-height: 420px;
          }
        }

        .contact-ghost {
          position: absolute;
          top: 28px;
          left: 48px;
          font-family: 'Bebas Neue', cursive;
          font-size: clamp(60px, 14vw, 180px);
          font-weight: 400;
          color: rgba(240,237,232,0.06);
          letter-spacing: 0.04em;
          pointer-events: none;
          user-select: none;
          white-space: nowrap;
          z-index: 0;
          line-height: 1;
          overflow: hidden;
          max-width: 100%;
        }

        .contact-hero-inner {
          position: relative;
          z-index: 1;
          max-width: 1360px;
          margin: 0 auto;
          padding: 0 52px;
        }

        .contact-sec-label {
          display: flex;
          align-items: center;
          gap: 14px;
          padding-bottom: 18px;
          border-bottom: 1px solid #1A1A1A;
          margin-bottom: 48px;
        }
        .contact-sec-label-num {
          font-family: 'Space Mono', monospace;
          font-size: 9.5px;
          color: #666;
          letter-spacing: 0.1em;
        }
        .contact-sec-label-text {
          font-family: 'Space Mono', monospace;
          font-size: 9.5px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #6D28D9;
        }
        .contact-sec-label-line {
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, #242424, transparent);
        }

        .contact-hero-top {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: start;
        }
        @media (max-width: 900px) {
          .contact-hero-top { grid-template-columns: 1fr; gap: 48px; }
        }

        .contact-h1 {
          font-family: 'Bebas Neue', cursive;
          font-size: clamp(72px, 10vw, 130px);
          line-height: 0.91;
          margin: 0 0 24px;
          color: #F0EDE8;
          letter-spacing: 0.01em;
        }
        .contact-h1 em {
          font-style: normal;
          display: block;
          background: linear-gradient(90deg, #7C3AED 0%, #00E5FF 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .contact-intro {
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          color: #666;
          line-height: 1.85;
          font-weight: 300;
          border-left: 2px solid #7C3AED;
          padding-left: 20px;
          max-width: 420px;
        }

        .contact-hero-right {
          display: flex;
          flex-direction: column;
          padding-top: 8px;
        }
        .contact-info-card {
          background: transparent;
          border-top: 1px solid #1A1A1A;
          padding: 28px 0;
          display: flex;
          flex-direction: column;
          gap: 8px;
          transition: background 0.2s, padding-left 0.2s;
        }
        .contact-info-card:last-child {
          border-bottom: 1px solid #1A1A1A;
        }
        .contact-info-card:hover {
          background: rgba(124,58,237,0.04);
          padding-left: 10px;
        }

        .contact-info-label {
          font-family: 'Space Mono', monospace;
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.18em;
          color: #6D28D9;
          text-transform: uppercase;
        }
        .contact-info-value {
          font-family: 'DM Sans', sans-serif;
          font-size: 15px;
          color: #F0EDE8;
          font-weight: 600;
          line-height: 1.5;
        }
        .contact-info-value a {
          color: #00E5FF;
          text-decoration: none;
          transition: opacity 0.2s;
        }
        .contact-info-value a:hover { opacity: 0.7; }

        .contact-info-sub {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          color: #888;
          line-height: 1.6;
          font-weight: 300;
        }

        /* ─── FORM SECTION ─── */
        .contact-body {
          max-width: 1360px;
          margin: 0 auto;
          padding: 72px 52px 120px;
        }
        @media (max-width: 900px) {
          .contact-body { padding: 48px 24px 80px; }
          .contact-hero-inner { padding: 0 24px; }
        }

        .contact-form-eyebrow {
          font-family: 'Space Mono', monospace;
          font-size: 9.5px;
          font-weight: 700;
          color: #6D28D9;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          margin-bottom: 10px;
        }

        .contact-form-title {
          font-family: 'Bebas Neue', cursive;
          font-size: clamp(28px, 3.5vw, 40px);
          color: #F0EDE8;
          margin-bottom: 8px;
          line-height: 1;
          letter-spacing: 0.02em;
        }

        .contact-form-sub {
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          color: #888;
          margin-bottom: 40px;
          line-height: 1.7;
          font-weight: 300;
          max-width: 560px;
        }

        .contact-form {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 24px;
          max-width: 860px;
        }
        .cf-field-full {
          grid-column: 1 / -1;
        }
        .cf-field {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        @media (max-width: 700px) {
          .contact-form { grid-template-columns: 1fr; }
          .cf-field-full { grid-column: 1; }
        }

        .cf-label {
          font-family: 'Space Mono', monospace;
          font-size: 9.5px;
          font-weight: 700;
          color: #F0EDE8;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          display: flex;
          align-items: baseline;
          gap: 8px;
          flex-wrap: wrap;
        }
        .cf-label-sub {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 400;
          color: #888;
          text-transform: none;
          letter-spacing: 0;
        }

        .cf-input, .cf-textarea {
          font-family: 'DM Sans', sans-serif;
          background: #111111;
          border: 1px solid #2A2A2A;
          border-radius: 0;
          padding: 13px 16px;
          color: #F0EDE8;
          font-size: 14px;
          font-weight: 400;
          outline: none;
          transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
          resize: vertical;
          width: 100%;
        }
        .cf-input:focus, .cf-textarea:focus {
          border-color: #7C3AED;
          background: rgba(124,58,237,0.08);
          box-shadow: 0 0 0 3px rgba(124,58,237,0.12);
        }
        .cf-input::placeholder, .cf-textarea::placeholder {
          color: #666;
          font-weight: 300;
        }
        .cf-textarea { min-height: 110px; }

        .cf-submit {
          font-family: 'Space Mono', monospace;
          font-size: 9.5px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #fff;
          background: linear-gradient(135deg, #7C3AED 0%, #00E5FF 100%);
          padding: 12px 28px;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          display: inline-block;
          transition: opacity 0.2s, transform 0.2s;
          margin-top: 8px;
        }
        .cf-submit:hover {
          opacity: 0.85;
          transform: translateY(-2px);
        }
        .cf-submit:active { transform: translateY(0); }

        .contact-focus {
          margin-top: 32px;
          border-top: 1px solid #1A1A1A;
          padding-top: 24px;
          max-width: 860px;
        }
        .contact-focus-label {
          font-family: 'Space Mono', monospace;
          font-size: 9px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #666;
          margin-bottom: 12px;
        }
        .contact-focus-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
        .contact-focus-tag {
          font-family: 'Space Mono', monospace;
          font-size: 8.5px;
          font-weight: 700;
          padding: 5px 14px;
          border: 1px solid #2A2A2A;
          color: #888;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          background: transparent;
          transition: border-color 0.2s, color 0.2s;
        }
        .contact-focus-tag:hover {
          border-color: #7C3AED;
          color: #F0EDE8;
        }

        .contact-hero { overflow: hidden; }

        @media (max-width: 768px) {
          .contact-ghost {
            font-size: clamp(40px, 12vw, 70px);
            left: 20px;
            top: 0px;
            opacity: 0.5;
            position: relative;
            display: block;
            margin-bottom: -40px;
            white-space: nowrap;
            overflow: hidden;
          }
          .contact-hero-inner { padding: 0 20px; }
          .contact-hero-top { grid-template-columns: 1fr; gap: 32px; }
          .contact-body { padding: 40px 20px 60px; }
          .contact-form { grid-template-columns: 1fr; }
          .cf-field-full { grid-column: 1; }
        }
        @media (max-width: 480px) {
          .contact-ghost { font-size: clamp(36px, 11vw, 60px); left: 0; top: 0; }
        }
      `}</style>

      <div className="contact-page">

        {/* ── SUCCESS POPUP ── */}
        {showPopup && <SuccessPopup onClose={() => setShowPopup(false)} />}

        {/* ── NAV ── */}
        <nav>
          <div className="nav-inner">
            <a href="/" className="nav-logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src="/amatres-logo2.jpg" alt="Amatres" style={{ width: '36px', height: '36px', objectFit: 'contain' }} />
              <span>Amatres<strong> Technologies</strong></span>
            </a>
            <div
              className={`mobile-menu-toggle ${isMobileMenuOpen ? 'open' : ''}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <span /><span /><span />
            </div>
            <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
              <li><HashLink smooth to="/#hero" onClick={() => setIsMobileMenuOpen(false)}>Home</HashLink></li>
              <li><HashLink smooth to="/#services" onClick={() => setIsMobileMenuOpen(false)}>Services</HashLink></li>
              <li><HashLink smooth to="/#expertise" onClick={() => setIsMobileMenuOpen(false)}>Expertise</HashLink></li>
              <li><HashLink smooth to="/#why" onClick={() => setIsMobileMenuOpen(false)}>Why Amatres</HashLink></li>

            </ul>
          </div>
        </nav>

        {/* ── HERO ── */}
        <div className="contact-hero">
          <div className="contact-ghost">CONTACT</div>
          <div className="contact-hero-inner">
            <div className="contact-sec-label">
              <span className="contact-sec-label-num">04 //</span>
              <span className="contact-sec-label-text">Get In Touch</span>
              <div className="contact-sec-label-line" />
            </div>

            <div className="contact-hero-top">
              <div>
                <h1 className="contact-h1">Let's <em>talk.</em></h1>
                <p className="contact-intro">
                  Share a brief overview of what you're building and your timeline.
                  We'll respond with next steps — typically within one business day.
                </p>
              </div>

              <div className="contact-hero-right">
                <div className="contact-info-card">
                  <div className="contact-info-label">Email</div>
                  <div className="contact-info-value">
                    <a href="mailto:connect@amatrestechnologies.in">connect@amatrestechnologies.in</a>
                  </div>
                  <div className="contact-info-sub">Prefer a quick start? Send a note and we'll take it from there.</div>
                </div>
                <div className="contact-info-card">
                  <div className="contact-info-label">Location</div>
                  <div className="contact-info-value">Bengaluru, India</div>
                </div>
                <div className="contact-info-card">
                  <div className="contact-info-label">Response time</div>
                  <div className="contact-info-value">Typically within 1 business day</div>
                  <div className="contact-info-sub">Suggested subject: Project Inquiry</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── FORM ── */}
        <div className="contact-body">
          <div className="contact-form-eyebrow">Project brief</div>
          <div className="contact-form-title">Tell us what you're building.</div>
          <div className="contact-form-sub">
            The details below help us respond with a clear plan and realistic milestones.
          </div>

          <form
            className="contact-form"
            onSubmit={async (e) => {
              e.preventDefault();
              const emailInput = e.target.email;
              const val = emailInput.value;
              const domain = val.split('@')[1];
              const domainName = domain?.split('.')[0];
              const tld = domain?.split('.').pop();
              if (!domain || domainName.length < 4 || tld.length < 2 || /^[^aeiou]{4,}$/i.test(domainName)) {
                emailInput.setCustomValidity('Please enter a real email address (e.g. you@gmail.com)');
                emailInput.reportValidity();
                return;
              }
              emailInput.setCustomValidity('');
              const formData = new FormData(e.target);
              formData.append('access_key', '5d138449-a3f4-417a-8c88-43786bce2618');
              const res = await fetch('https://api.web3forms.com/submit', {
                method: 'POST',
                body: formData
              });
              const data = await res.json();
              if (data.success) {
                e.target.reset();
                e.target.dispatchEvent(new Event('reset', { bubbles: true }));
                setShowPopup(true); // ← Triggers the popup
              } else {
                alert("Something went wrong. Please email us directly at connect@amatrestechnologies.in");
              }
            }}
          >
            <input type="hidden" name="subject" value="New Project Inquiry — Amatres" />
            <input type="hidden" name="from_name" value="Amatres Website" />

            <div className="cf-field cf-field-full">
              <label className="cf-label">
                Scope <span className="cf-label-sub">What are you building or improving?</span>
              </label>
              <textarea
                name="scope"
                className="cf-textarea"
                placeholder="e.g. We need to rebuild our patient portal with EHR integration and real-time tracking..."
                rows={3}
                required
                minLength={20}
                title="Please describe your project in at least 20 characters"
              />
            </div>

            <div className="cf-field">
              <label className="cf-label">
                Timeline <span className="cf-label-sub">Target dates, milestones.</span>
              </label>
              <input
                name="timeline"
                className="cf-input"
                type="text"
                placeholder="e.g. MVP by Q3 2025"
                required
                pattern="^(?=.*[a-zA-Z]{3,})(?=.*(\d{4}|\d+\s*(month|week|day|year))).{6,}$"
                title="Please enter a valid timeline (e.g. MVP by Q3 2025, 3 months, by June 2026)"
              />
            </div>

            <div className="cf-field cf-field-full">
              <label className="cf-label">
                Stack <span className="cf-label-sub">Current stack, cloud, repos. Pick all that apply.</span>
              </label>
              <StackSelector name="stack" />
            </div>

            <div className="cf-field">
              <label className="cf-label">
                Budget <span className="cf-label-sub">Optional range or model.</span>
              </label>
              <input
                name="budget"
                className="cf-input"
                type="text"
                placeholder="e.g. $20-40k, or retainer"
                required
                pattern="^(?=.*[\d$£€kKmMrR]|retainer|monthly|weekly|hourly).{3,}$"
                title="Please enter a valid budget (e.g. $20-40k, ₹5L, retainer, monthly)"
              />
            </div>

            <div className="cf-field">
              <label className="cf-label">Your email</label>
              <input
                name="email"
                className="cf-input"
                type="email"
                placeholder="you@gmail.com or you@company.com"
                required
                pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
                title="Enter a valid email — domain must have at least 3 characters (e.g. you@gmail.com)"
                onBlur={e => {
                  const val = e.target.value;
                  const domain = val.split('@')[1];
                  if (!domain) return;
                  const domainName = domain.split('.')[0];
                  const tld = domain.split('.').pop();
                  if (domainName.length < 3 || tld.length < 2) {
                    e.target.setCustomValidity('Please enter a real email address (e.g. you@gmail.com)');
                  } else if (/^[^aeiou]{4,}$/i.test(domainName)) {
                    e.target.setCustomValidity('This does not look like a valid email domain');
                  } else {
                    e.target.setCustomValidity('');
                  }
                }}
              />
            </div>
            <div className="cf-field cf-field-full" style={{ gridColumn: '1/-1', textAlign: 'center' }}>
              <button type="submit" className="cf-submit">Send brief →</button>
            </div>
          </form>

          <div className="contact-focus">
            <div className="contact-focus-label">Typical focus areas</div>
            <div className="contact-focus-tags">
              <span className="contact-focus-tag">AWS &amp; Cloud-Native</span>
              <span className="contact-focus-tag">M365</span>
              <span className="contact-focus-tag">Product Engineering</span>
              <span className="contact-focus-tag">LLM Integrations</span>
            </div>
          </div>
        </div>

        <FooterContent />
      </div>
    </>
  );
}